	interface Event
	{
		event : string;
		handler : Function;
		repeatable : boolean;
	}

	export class Collection
	{
		private TAG;

		_events : Event[] = [];

		constructor(name : string)
		{
			this.TAG = "[Collection<" + name + ">]"
		}

		on(event : string | string[], handler : Function)
		{
			// logging.log(this.TAG, "on", event, this._events.slice());

			if (event instanceof Array) {
				for (let i = 0; i < event.length; i++) {
					this.on(event[i], handler);
				}
			} else {
				this._events.push({
					event : <string> event,
					handler : handler,
					repeatable : true
				});
			}
		}

		trigger(event : string, ...params)
		{
			// logging.log(this.TAG, "trigger", event, params, this._events.slice());

			for(var i = this._events.length - 1; i>=0; i--)
			{
				var evt = this._events[i];

				if (evt.event === event)
				{
					evt.handler(...params);
					if (!evt.repeatable) {
						this._events.splice(i, 1);
					}
				}
				else if (evt.event === "*")
				{
					evt.handler(event, ...params);
					if (!evt.repeatable) {
						this._events.splice(i, 1);
					}
				}
			}
		}

		one(event : string, handler : Function = null)
		{
			this._events.push({
				event : event,
				handler : handler,
				repeatable : false
			});
			// logging.log(this.TAG, "one", event, this._events.slice());
		}

		off(event : string, handler : Function = null)
		{
			// logging.log("event.off", event);
			for(var i=this._events.length - 1; i>=0; i--)
			{
				if (this._events[i].event === event) {
					if (!handler || this._events[i].handler == handler) {
						this._events.splice(i, 1);
					}
				}
			}
		}
	}
